import React, { useCallback } from 'react';

import { useModalStore } from 'bdvp-common/src/hooks/store';

import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useSelectedFiltersStore from '../hooks/store/useSelectedFiltersStore';
import useFieldsQuery from '../hooks/store/useFieldsQuery';
import useFiltersConfig from '../hooks/useFiltersConfig';

import Component from '../components/FilterPanel';

const { FILTER_MODAL_NAME } = modalConstants;

const FilterPanel = () => {

    const {
        selectedFilters,
        clearFilters,
        applyFilters,
        resetFilters,
        removeSelectedFilter,
        addSelectedFilter,
    } = useSelectedFiltersStore();
    const {
        fieldsIds = {},
        filtersConfig,
    } = useFiltersConfig();
    const {
        loadFields,
        called,
        loading,
        data,
    } = useFieldsQuery(fieldsIds.withValues, fieldsIds.withoutValues);
    const {
        modalHide,
    } = useModalStore();
    const closeFilterModal = useCallback(() => modalHide(FILTER_MODAL_NAME), [modalHide]);

    return (
        <Component
            loadFields={loadFields}
            loading={!called || loading}
            data={data}
            selectedFilters={selectedFilters || []}
            removeSelectedFilter={removeSelectedFilter}
            addSelectedFilter={addSelectedFilter}
            clearFilters={clearFilters}
            applyFilters={applyFilters}
            resetFilters={resetFilters}
            closeFilterModal={closeFilterModal}
            filtersConfig={filtersConfig}
        />
    );

};

export default FilterPanel;
